import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MatDrawer } from '@angular/material/sidenav';

import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { NavigationEnd, Router } from '@angular/router';

@UntilDestroy()
@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit {
    @ViewChild('drawer') drawer: MatDrawer | undefined;

    public displaySidenavClass!: boolean;

    constructor(
        private readonly sidenavService: SidenavService,
        private router: Router,
    ) {
        inject(BreakpointObserver)
            .observe(sidenavService.breakPointsThreshold)
            .pipe(untilDestroyed(this))
            .subscribe((result) => {
                const matches = result.matches;
                this.displaySidenavClass = !matches;
            });
    }

    ngOnInit(): void {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                const mainContainer = document.querySelector('.main-container');
                if (mainContainer) {
                    mainContainer.scrollTop = 0;
                }
            }
        });

        this.sidenavService.toggleSidenavObs$
            .pipe(untilDestroyed(this))
            .subscribe((toggle) => this.drawer?.toggle());

        // do not reset sidenav for now, but i have the feeling this will change again soon
        // this.sidenavService.setTopMenuItems([]);
    }

    public toggleSidenav(): void {
        this.drawer?.toggle();
    }
}
